// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__39ezY","colMin":"styles_colMin__1cx6V","colCheckbox":"styles_colCheckbox__1aeWl"};